/* eslint-disable */
import ReactDOM from 'react-dom/client'
import 'antd/dist/antd.css'
import './index.css'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { StyledEngineProvider } from '@mui/material/styles'
import { msalConfig } from './config/authConfig'
import App from './App'
import reportWebVitals from './reportWebVitals'
import LayoutThemeProvider from './context/LayoutThemeContext'

// Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig)

// Wait for initialize before calling any API
const startApp = async () => {
  try {
    await msalInstance.initialize() // ⭐ important
    await msalInstance.handleRedirectPromise() // process auth code/hash before routing

    const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

    root.render(
      <MsalProvider instance={msalInstance}>
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID!}>
          <StyledEngineProvider injectFirst>
            <LayoutThemeProvider>
              <App />
            </LayoutThemeProvider>
          </StyledEngineProvider>
        </GoogleOAuthProvider>
      </MsalProvider>
    )
  } catch (err) {
    console.error('MSAL Initialization Error:', err)
  }
}

// Start app
startApp()

reportWebVitals()
